import {
  Error as CwbApiError,
  UpdateUserConsentResponseSchema,
} from "@amzn/client-workbench-api-model";
import { AxiosError } from "axios";
import { useMutation, UseMutationResult } from "react-query";

import { submitUserConsents } from "@/apis/UserConsentsHelper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";

/**
 * Custom hook to invoke the API call to store user consents in the DDB.
 */
export const useSubmitUserConsents = (): UseMutationResult<
  UpdateUserConsentResponseSchema,
  AxiosError<CwbApiError>
> => {
  return useMutation<
    UpdateUserConsentResponseSchema,
    AxiosError<CwbApiError>,
    unknown,
    unknown
  >("submitUserConsents", submitUserConsents, {
    /**
     * By default, React Query will not retry a mutation on error. Only retry on Axios errors with a transient error
     * code if the failure count is within the retry limit.
     */
    retry: shouldRetry,
    retryDelay: getRetryDelayMs,
  });
};
